var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElPencilAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_4586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.01172 0.000488281C3.14572 0.000488281 0.0117188 3.13449 0.0117188 7.00049C0.0117188 10.8665 3.14572 14.0005 7.01172 14.0005C10.8777 14.0005 14.0117 10.8665 14.0117 7.00049C14.0117 3.13449 10.8777 0.000488281 7.01172 0.000488281ZM9.36676 2.1871C9.57198 2.18872 9.77121 2.26442 9.92172 2.41494L11.0866 3.57939C11.4086 3.9014 11.3866 4.44394 11.0383 4.79304C10.6892 5.14216 10.1458 5.16292 9.82466 4.8418L8.6602 3.67736C8.33818 3.35623 8.3607 2.81196 8.70896 2.46371C8.89398 2.27822 9.13421 2.18527 9.36676 2.1871ZM7.44745 3.72567L9.77679 6.05457L5.99133 9.83913L3.66199 7.5098L7.44745 3.72567ZM3.05737 7.95084L5.51437 10.4079L2.44213 11.0231L3.05737 7.95084Z",
    fill: "#999999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_4586"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.0117188 0.000488281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElPencilAlt);
export default __webpack_public_path__ + "static/media/el_pencil-alt.7f89262e9874d3c39ff1f25b1d66778d.svg";
export { ForwardRef as ReactComponent };